<template>
    <div class="box center">
        <div class="flex">
            <div class="flex1"> 
                    <p class="small_font">总战绩 (元)</p>
                    <p class="big_font">{{ profit.total / 100 }}</p>
            </div>
        </div>
        <div class="flex" style="margin-top: 0.07rem;">
            <div class="left flex1"> 
                <p class="nomal_font">{{ property.balance / 100 }}</p>
                <p class="small_font">余额</p>
            </div>
            <div class="border"></div>
            <div class="right flex1">
                <p class="nomal_font">{{ property.blocking / 100 }}</p>
                <p class="small_font">
                    冻结
                    <span class="tip" v-tip.bottom="options" :options="options">?</span>    
                </p>
            </div>
            <div class="border"></div>
            <div class="right flex1">
                <p class="nomal_font">{{ property.usable / 100 }}</p>
                <p class="small_font">可提现</p>
            </div>
        </div>
        <br />
        <div class="center flex">
            <div class="flex1">
               <!-- <router-link  to="/user/withDraw">-->
                    <div class="button" @click="toWithDraw">提现</div>
                <!--</router-link>-->		   
            </div>
        </div>
    </div>
</template>

<script>

export default {
  props: ['property', 'profit'],
  name: 'Header',
  data() {
        return {
            options: {
                title: '冻结原因：',
                content: '申请提现部分及发放不满7天的'
            },
        }
  },
  methods: {
  	toWithDraw(){
  		this.$router.push({path:'/user/withDraw'});
  	}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tip {
    border: 1px solid #fff;
    border-radius: 50%;
    width: .14rem;
    height: .14rem;
    display: inline-block;
    position: relative;
    line-height: .15rem;
    font-size: .12rem;
}
</style>



// WEBPACK FOOTER //
// src/components/userProfitElement/Header.vue